import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getAppParams, getUrlParams } from "../apiService/timespam";
import "./Theme.css";
import "./AddictionAssessment.css";
import { APIV4_BASE_URL } from "../apiService/apiClient";

const QUESTIONS = [
  { id: 17, category: "Nicotine", question: "Do you smoke or have you ever smoked?", options: ["Yes, I currently smoke.", "No, I have never smoked.", "I used to smoke but I have quit."], scores: [null, 0, 0], endSurveyOn: [false, true, true] },
  { id: 18, category: "Nicotine", question: "How soon after you wake do you smoke your first cigarette?", options: ["Within 5 minutes", "6-30 minutes", "31-60 minutes", "After 60 minutes"], scores: [3, 2, 1, 0] },
  { id: 19, category: "Nicotine", question: "Do you find it difficult to refrain from smoking in places where it is forbidden?", options: ["Yes", "No"], scores: [1, 0] },
  { id: 20, category: "Nicotine", question: "Which cigarette would you hate most to give up?", options: ["The first one in the morning", "All others"], scores: [1, 0] },
  { id: 21, category: "Nicotine", question: "How many cigarettes do you typically smoke per day?", options: ["10 or less", "11-20", "21-30", "31 or more"], scores: [0, 1, 2, 3] },
  { id: 22, category: "Nicotine", question: "Do you smoke more frequently during the first hours after waking than during the rest of the day?", options: ["Yes", "No"], scores: [1, 0] },
  { id: 23, category: "Nicotine", question: "Do you smoke even if you are so ill that you are in bed most of the day?", options: ["Yes", "No"], scores: [1, 0] },
  { id: 24, category: "Drug", question: "Have you used drugs other than those required for medical reasons?", options: ["Yes, I currently use drugs.", "No, I have never used drugs.", "I used to use drugs but have quit."], scores: [1, 0, 0], endSurveyOn: [false, true, true] },
  { id: 25, category: "Drug", question: "Do you use more than one drug at a time?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 26, category: "Drug", question: "Are you always able to stop using drugs when you want to?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 27, category: "Drug", question: "Have you had \"blackouts\" or \"flashbacks\" as a result of drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 28, category: "Drug", question: "Do you ever feel bad or guilty about your drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 29, category: "Drug", question: "Does your spouse (or parents) ever complain about your involvement with drugs?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 30, category: "Drug", question: "Have you neglected your family because of your use of drugs?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 31, category: "Drug", question: "Have you engaged in illegal activities to obtain drugs?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 32, category: "Drug", question: "Have you ever experienced withdrawal symptoms when you stopped taking drugs?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 33, category: "Drug", question: "Have you had medical problems as a result of your drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 34, category: "Drug", question: "Have you gone to anyone for help for a drug problem?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 35, category: "Drug", question: "Have you been involved in a treatment program specifically for drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 36, category: "Drug", question: "Do you take drugs more often than you intended?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 37, category: "Drug", question: "Have you overdosed on drugs?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 38, category: "Drug", question: "Do you avoid people or places that don't approve of your drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 39, category: "Drug", question: "Have you lost interest in activities or hobbies due to drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 40, category: "Drug", question: "Have you had legal problems due to your drug use?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 41, category: "Drug", question: "Have you used drugs to relieve feelings of sadness, anger, or boredom?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 42, category: "Drug", question: "Have you continued to use drugs despite negative consequences?", options: ["YES", "NO"], scores: [1, 0] },
  { id: 43, category: "Drug", question: "Have you tried and failed to stop using drugs?", options: ["YES", "NO"], scores: [1, 0] },
];

const getNicotineLabel = (s) => {
  if (s === 0) return { label: "No Dependence", color: "#66bb6a", suggestion: "You do not smoke or have successfully quit. Maintain your smoke-free lifestyle for lasting health benefits." };
  if (s <= 2) return { label: "Low Dependence", color: "#42a5f5", suggestion: "Mild nicotine dependence detected. Gradually reduce smoking and seek advice if needed." };
  if (s <= 4) return { label: "Moderate Dependence", color: "#FBC525", suggestion: "Moderate nicotine addiction detected. Behavioral therapy or nicotine replacement strategies can help." };
  if (s <= 7) return { label: "High Dependence", color: "#ffa726", suggestion: "Significant nicotine dependence identified. Seek professional support and explore cessation strategies." };
  return { label: "Very High Dependence", color: "#ef5350", suggestion: "Strong nicotine addiction detected. Professional guidance, including counseling or medications, is strongly recommended." };
};
const getDrugLabel = (s) => {
  if (s <= 2) return { label: "No Dependence", color: "#66bb6a", suggestion: "No immediate action needed. Stay informed about the risks of drug use." };
  if (s <= 5) return { label: "Low Dependence", color: "#66bb6a", suggestion: "You may benefit from occasional monitoring. Consider learning more about drug use behaviors." };
  if (s <= 8) return { label: "Moderate Dependence", color: "#42a5f5", suggestion: "Consider a brief intervention or check-in with a healthcare provider." };
  if (s <= 12) return { label: "High Dependence", color: "#FBC525", suggestion: "It is important to speak with a health professional. Possibly treatment is recommended." };
  return { label: "Very High Dependence", color: "#ffa726", suggestion: "A comprehensive evaluation is essential. Consider therapy, counseling, or treatment programs." };
};

const ColorBar = ({ score, sections }) => (
  <div className="ad-color-bar">
    {sections.map((s, i) => {
      const active = score >= s.start && score <= s.end;
      return (
        <div key={i} className="ad-color-seg" style={{
          flex: 1,
          backgroundColor: active ? s.color : "var(--border-subtle)",
          borderRight: i < sections.length - 1 ? "2px solid var(--bg-card)" : "none",
        }} />
      );
    })}
  </div>
);

const NicotineDrugAssessment = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const { goqiiUserId, nonce, apiKey, signature, goqiiAccessToken, appVersion, appType } = getAppParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    if (lang === "ar") document.documentElement.dir = "rtl";
  }, [theme, lang]);

  const [currentIdx, setCurrentIdx] = useState(0);
  const [answers, setAnswers] = useState({});
  const [slideKey, setSlideKey] = useState(0);
  const [answerDisabled, setAnswerDisabled] = useState(false);
  const [showFinish, setShowFinish] = useState(false);
  const [prevIdx, setPrevIdx] = useState(null);
  const [nicotineScore, setNicotineScore] = useState(0);
  const [drugScore, setDrugScore] = useState(0);
  const [view, setView] = useState("quiz");
  const [result, setResult] = useState(null);

  const goNext = (nextIdx) => {
    setTimeout(() => {
      setCurrentIdx(nextIdx);
      setSlideKey((k) => k + 1);
    }, 300);
  };

  const handleAnswerChange = (optionIdx) => {
    if (answerDisabled) return;
    setAnswerDisabled(true);
    setTimeout(() => setAnswerDisabled(false), 500);

    const q = QUESTIONS[currentIdx];
    const score = q.scores[optionIdx] ?? 0;
    setAnswers((prev) => ({ ...prev, [currentIdx]: optionIdx }));
    setPrevIdx(currentIdx);

    if (currentIdx < 7) setNicotineScore((p) => p + score);
    else setDrugScore((p) => p + score);

    if (q.id === 17) {
      setShowFinish(false);
      if (optionIdx === 1 || optionIdx === 2) { goNext(7); return; }
      else { goNext(1); return; }
    }
    if (q.id === 24) {
      if (optionIdx === 1 || optionIdx === 2) { setShowFinish(true); return; }
      else { setShowFinish(false); goNext(8); return; }
    }
    if (currentIdx < QUESTIONS.length - 1) goNext(currentIdx + 1);
  };

  const handlePrevious = () => {
    setShowFinish(false);
    if (currentIdx === 7 && prevIdx === 0) { setCurrentIdx(0); setSlideKey((k) => k + 1); return; }
    if (currentIdx > 0) { setCurrentIdx((p) => Math.max(p - 1, 0)); setSlideKey((k) => k + 1); }
  };

  const handleNext = () => {
    const q = QUESTIONS[currentIdx];
    const sel = answers[currentIdx];
    if (sel === undefined) return;
    if (q.id === 17 && (sel === 1 || sel === 2)) { goNext(7); return; }
    if (q.id === 24 && (sel === 1 || sel === 2)) { setShowFinish(true); return; }
    if (currentIdx < QUESTIONS.length - 1) goNext(currentIdx + 1);
  };

  const handleFinish = () => {
    const nInfo = getNicotineLabel(nicotineScore);
    const dInfo = getDrugLabel(drugScore);

    const preparedQuestions = Object.keys(answers).map((key) => ({
      questionId: QUESTIONS[key].id,
      question: "",
      answer: answers[key] || 0,
      score: QUESTIONS[key].scores[answers[key]] ?? 0,
      category: QUESTIONS[key].category,
    }));

    const scoreData = {
      mentalWellnessScore: 0,
      mentalWellnessLabel: "",
      anxietyScore: nicotineScore,
      depressionScore: drugScore,
      anxietyLabel: nInfo.label,
      depressionLabel: dInfo.label,
    };

    const qs = new URLSearchParams({
      questions: JSON.stringify(preparedQuestions),
      scoreData: JSON.stringify(scoreData),
      goqiiUserId, nonce, signature, apiKey, goqiiAccessToken, appVersion, appType,
      type: "addiction",
      subType: "smoking_drugs",
    }).toString();

    fetch(`${APIV4_BASE_URL}/lab/save_mental_health_assessment?${qs}`).catch(console.error);
    setResult({ nicotineScore, drugScore, nicotineInfo: nInfo, drugInfo: dInfo });
    setTimeout(() => setView("result"), 1000);
  };

  const progress =
    (QUESTIONS[currentIdx]?.id === 17 && (answers[currentIdx] === 1 || answers[currentIdx] === 2)) ||
    (QUESTIONS[currentIdx]?.id === 24 && (answers[currentIdx] === 1 || answers[currentIdx] === 2))
      ? 100
      : ((currentIdx + 1) / QUESTIONS.length) * 100;

  const canShowNext = answers[currentIdx] !== undefined && !showFinish && currentIdx < QUESTIONS.length - 1;
  const canFinish = showFinish || currentIdx === QUESTIONS.length - 1;

  /* ---- RESULT VIEW ---- */
  if (view === "result" && result) {
    return (
      <div className="ad-wrapper">
        <div className="ad-result-card">
          <p className="ad-result-title">Your Addiction Assessment Results</p>

          <p className="ad-result-section-title">Smoking/Nicotine Addiction Risk</p>
          <p className="ad-score-text" style={{ color: result.nicotineInfo.color }}>{result.nicotineInfo.label} (Score: {result.nicotineScore} / 10)</p>
          <p className="ad-score-note">{result.nicotineInfo.suggestion}</p>
          <ColorBar score={result.nicotineScore} sections={[
            { start: 0, end: 2, color: "#66bb6a" }, { start: 3, end: 4, color: "#ffa726" },
            { start: 5, end: 7, color: "#ff7043" }, { start: 8, end: 10, color: "#d32f2f" },
          ]} />

          <hr className="ad-divider" />

          <p className="ad-result-section-title">Drug Addiction Risk</p>
          <p className="ad-score-text" style={{ color: result.drugInfo.color }}>{result.drugInfo.label} (Score: {result.drugScore} / 20)</p>
          <p className="ad-score-note">{result.drugInfo.suggestion}</p>
          <ColorBar score={result.drugScore} sections={[
            { start: 0, end: 2, color: "#66bb6a" }, { start: 3, end: 5, color: "#0000FF" },
            { start: 6, end: 8, color: "#FBC525" }, { start: 9, end: 12, color: "#FFA500" },
            { start: 13, end: 20, color: "#ff0000" },
          ]} />

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <button className="ad-btn-primary" style={{ width: "auto", padding: "10px 32px" }} onClick={() => {
              window.location.href = `/addiction_assessment${window.location.search}`;
            }}>{t("addictionAssessment.close")}</button>
          </div>
        </div>
      </div>
    );
  }

  /* ---- QUIZ VIEW ---- */
  const q = QUESTIONS[currentIdx];
  return (
    <div className="ad-wrapper">
      <p className="ad-quiz-intro">Over the Past Week</p>
      <div key={slideKey} className="ad-question-card">
        <p className="ad-question-text">{currentIdx + 1}: {q.question}</p>
        <div className="ad-options">
          {q.options.map((opt, i) => (
            <label
              key={i}
              className={`ad-option${answers[currentIdx] === i ? " selected" : ""}`}
              onClick={() => handleAnswerChange(i)}
            >
              <input type="radio" name={`q${currentIdx}`} checked={answers[currentIdx] === i} onChange={() => {}} />
              <span className="ad-option-label">{opt}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="ad-quiz-footer">
        <button className="ad-btn-outline" onClick={handlePrevious} disabled={currentIdx === 0}>{t("addictionAssessment.previous")}</button>
        <div className="ad-progress-wrap">
          <div className="ad-progress-bar" style={{ width: `${progress}%` }} />
        </div>
        {canFinish ? (
          <button className="ad-btn-contained" onClick={handleFinish}>{t("addictionAssessment.finish")}</button>
        ) : (
          <button className="ad-btn-contained" onClick={handleNext} disabled={answers[currentIdx] === undefined}>{t("addictionAssessment.next")}</button>
        )}
      </div>
    </div>
  );
};

export default NicotineDrugAssessment;
